module.exports = __webpack_public_path__ + "static/media/pay.64d282a4.svg";